import router from '@/router';
import isNil from 'lodash/isNil';
import { createNewUserFromFirebaseAuthUser } from '@/misc/helpers';
import UsersDB from '@/firebase/users-db';

export default {
    /**
     * Callback fired when user login
     */
    login: async({ commit, dispatch }, firebaseAuthUser) => {
        const userFromFirebase = await new UsersDB().read(firebaseAuthUser.uid); // get currentUser uid if user is stored in db if not set new User (firebaseAuthUser)
        const user = isNil(userFromFirebase) ?
            await createNewUserFromFirebaseAuthUser(firebaseAuthUser) // if there is no user => create new User
            :
            userFromFirebase; // else if there is a user
        commit('user/SET_USERPROFILE', user, { root: true });
        dispatch('posts/getUserProducts', firebaseAuthUser.uid, { root: true });
    },

    /**
     * Callback fired when user logout
     */
    logout: ({ commit }) => {
        commit('user/SET_USERPROFILE', null, { root: true });
        commit('user/SET_CURRENTUSER', null, { root: true });

        const currentRouter = router.app.$route;

        if (!(currentRouter.meta && currentRouter.meta.requiresAuth)) {
            router.push('/login');
        }
    },
};